/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import $ from "jquery";
import BuddibleSocket, { MsgIDList } from "../lib/BuddibleSocket";
import Utilities from "../lib/Utilities";
import CodeList from "../lib/CodeList";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

const socket = new BuddibleSocket();
const codeList = new CodeList();
const util = new Utilities();

const _mClassName = "LoginModal";

export default function LoginModal({ setIsLogin, toggleMobileNavOpen }) {
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();
  const $company = useRef();
  const $userSite = useRef();
  const $userID = useRef();
  const $userPW = useRef();
  const $saveID = useRef();

  useEffect(() => {
    resizeLayout();
    window.addEventListener("resize", resizeLayout);
    $company.current.checked = true;
    socket.addLocalEventListener(
      MsgIDList.EVENT_SOCKET_DATA_ERROR,
      _mClassName,
      (b, n) => {
        setLoading(false);
      }
    );

    return () => {
      window.removeEventListener("resize", resizeLayout);
      socket.removeLocalEventListener(
        MsgIDList.EVENT_SOCKET_DATA_ERROR,
        _mClassName
      );
    };
  }, []);

  useEffect(() => {
    let loginInfo = sessionStorage.getItem("loginInfo");
    if (loginInfo === null) loginInfo = localStorage.getItem("loginInfo");

    try {
      loginInfo = util.buddibleDecrypt(loginInfo);
      loginInfo = JSON.parse(loginInfo);
    } catch (e) {
      loginInfo = null;
      sessionStorage.removeItem("loginInfo");
    }
    if (loginInfo !== null) {
      if (
        !loginInfo.hasOwnProperty("user_id") ||
        !loginInfo.hasOwnProperty("user_pw") ||
        !loginInfo.hasOwnProperty("comp_cd")
      ) {
        sessionStorage.removeItem("loginInfo");
        localStorage.removeItem("loginInfo");
        return;
      }
      $userID.current.value = util.buddibleDecrypt(loginInfo.user_id);
      $userPW.current.value = util.buddibleDecrypt(loginInfo.user_pw);
      $userSite.current.value = util.buddibleDecrypt(loginInfo.comp_cd);
    }
  });

  function resizeLayout() {
    if (window.innerWidth >= 768) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  }

  function changeAccountType(e) {
    if (e.target.value === "personal") {
      $userSite.current.value = "Y0001";
      $userSite.current.disabled = true;
      $userSite.current.hidden = true;
    } else {
      $userSite.current.value = "";
      $userSite.current.disabled = false;
      $userSite.current.hidden = false;
    }
  }

  function closeLoginModal() {
    $("#loginModalClose").click();
    setTimeout(function () {
      $("body").addClass("modal-open");
    }, 400);
  }

  //login 이벤트 실행
  function actionLogin(e) {
    setLoading(true);
    if (checkLoginValidation()) {
      requestLogin({
        user_id: util.buddibleEncrypt($userID.current.value),
        user_pw: util.buddibleEncrypt($userPW.current.value),
        comp_cd: util.buddibleEncrypt($userSite.current.value),
      });
    } else {
      setLoading(false);
    }
  }

  //아이디 패스워드 입력 검사
  function checkLoginValidation() {
    if ($userSite.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("commonNav.loginModal.msg.enterCompCD"),
        () => {}
      );
      return false;
    }
    if ($userID.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("commonNav.loginModal.msg.enterID"),
        () => {}
      );
      return false;
    }
    if ($userPW.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("commonNav.loginModal.msg.enterPW"),
        () => {}
      );
      return false;
    }

    return true;
  }

  //로그인정보 전송
  function requestLogin(updateData) {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/login/JS_login_gbts.php",
      msgID: msgID,
      data: {},
      ...updateData,
    };
    setLoading(true);
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"] === true) {
          setLoading(false);

          socket.sendLocalMessage(
            MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
            "HeaderAccController",
            newData,
            () => {}
          );
          let date = new Date();
          newData["storageLifeTime"] = date.setDate(date.getDate() + 300);

          sessionStorage.setItem(
            "loginInfo",
            util.buddibleEncrypt(JSON.stringify(newData))
          );
          if ($saveID.current.value) {
            localStorage.setItem(
              "loginInfo",
              util.buddibleEncrypt(JSON.stringify(newData))
            );
          }

          codeList.Modal.current.alert(
            t("commonNav.loginModal.msg.successLogin"),
            () => {
              $userID.current.value = "";
              $userPW.current.value = "";
              setIsLogin(true);
              window.location.replace("/");
            }
          );
          $("#loginModalClose").click();
        } else {
          setLoading(false);
          codeList.Modal.current.alert(
            newData["msg"]
              ? newData["msg"]
              : t("commonNav.loginModal.msg.failLogin"),
            () => {}
          );
        }
      }
    });
  }

  if (isMobile) {
    return (
      <div
        className="modal fade"
        id="loginModal"
        tabIndex="-1"
        aria-labelledby="loginModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog p-0 m-0 bg-transparent" />
        <div className="vw-100 vh-100 bg-white d-flex flex-column d-md-none">
          <div className="modal-header">
            <h3 className="modal-title h6 font-weight-bold m-0 p-0 text-freiscop">
              {t("commonNav.loginModal.title")}
            </h3>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="loginModalClose"
              onClick={() => {
                $("#loginModalClose").click();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body flex-fill">
            <div className="h-100 d-flex flex-column justify-content-between">
              <div>
                <div className="clearfix">
                  <div className="checkboxes float-left">
                    <label
                      className="container_radio mr-3"
                      style={{ lineHeight: "unset", paddingLeft: 25 }}
                    >
                      {t("commonNav.loginModal.compUser")}
                      <input
                        type="radio"
                        name="compType"
                        value="company"
                        defaultChecked
                        ref={$company}
                        onClick={(e) => {
                          changeAccountType(e);
                        }}
                      />
                      <span className="checkmark" />
                    </label>
                  </div>
                  <div className="checkboxes float-left">
                    <label
                      className="container_radio"
                      style={{ lineHeight: "unset", paddingLeft: 25 }}
                    >
                      {t("commonNav.loginModal.personalUser")}
                      <input
                        type="radio"
                        name="compType"
                        value="personal"
                        onClick={(e) => {
                          changeAccountType(e);
                        }}
                      />
                      <span className="checkmark" />
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <input
                    className="form-control p-3"
                    type="text"
                    placeholder={t("commonNav.loginModal.compCode")}
                    ref={$userSite}
                    onKeyPress={(e) => {
                      if (e.charCode === 13) {
                        actionLogin();
                      }
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="form-control p-3"
                    type="text"
                    placeholder={t("commonNav.loginModal.id")}
                    ref={$userID}
                    onKeyPress={(e) => {
                      if (e.charCode === 13) {
                        actionLogin();
                      }
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="form-control p-3"
                    type="password"
                    placeholder={t("commonNav.loginModal.password")}
                    ref={$userPW}
                    onKeyPress={(e) => {
                      if (e.charCode === 13) {
                        actionLogin();
                      }
                    }}
                  />
                </div>
                <div className="clearfix add_bottom_15">
                  <div className="checkboxes float-left">
                    <label className="container_check" htmlFor="saveID">
                      {t("commonNav.loginModal.autoLogin")}
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="saveID"
                        ref={$saveID}
                      />
                      <span className="checkmark" />
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <div className="d-flex flex-row justify-content-center mb-3">
                  <a
                    className="text-secondary cursor_pointer_fw_bold"
                    data-toggle="modal"
                    data-target="#findIDModal"
                    href="#"
                    onClick={() => {
                      closeLoginModal();
                    }}
                  >
                    <p>{t("commonNav.loginModal.findID")}</p>
                  </a>
                  <p> | </p>
                  <a
                    className="text-secondary cursor_pointer_fw_bold"
                    data-toggle="modal"
                    data-target="#findPWModal"
                    href="#"
                    onClick={() => {
                      closeLoginModal();
                    }}
                  >
                    <p>{t("commonNav.loginModal.findPW")}</p>
                  </a>
                  <p> | </p>
                  <Link
                    className="text-secondary cursor_pointer_fw_bold"
                    to="/DeleteAccount"
                    onClick={() => {
                      toggleMobileNavOpen();
                      $("#loginModalClose").click();
                    }}
                  >
                    <p>{t("commonNav.loginModal.requestDeleteAccount")}</p>
                  </Link>
                </div>
                <div className="text-center">
                  <button
                    value="Log In"
                    className="w-100 btn_1"
                    onClick={() => actionLogin()}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        Loading ...
                        <div
                          className="spinner-border spinner-border-sm text-light"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </>
                    ) : (
                      "Log in"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className="modal fade"
        id="loginModal"
        tabIndex="-1"
        aria-labelledby="loginModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered d-none d-md-flex">
          <div className="modal-content">
            <div className="modal-header py-2">
              <h3 className="modal-title h6 font-weight-bold m-0 p-0 text-freiscop">
                {t("commonNav.loginModal.title")}
              </h3>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="loginModalClose"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="sign-in-wrapper">
                <div className="clearfix">
                  <div className="checkboxes float-left">
                    <label
                      className="container_radio mr-3"
                      style={{ lineHeight: "unset", paddingLeft: 25 }}
                    >
                      {t("commonNav.loginModal.compUser")}
                      <input
                        type="radio"
                        name="compType"
                        value="company"
                        defaultChecked
                        ref={$company}
                        onClick={(e) => {
                          changeAccountType(e);
                        }}
                      />
                      <span className="checkmark" />
                    </label>
                  </div>
                  <div className="checkboxes float-left">
                    <label
                      className="container_radio"
                      style={{ lineHeight: "unset", paddingLeft: 25 }}
                    >
                      {t("commonNav.loginModal.personalUser")}
                      <input
                        type="radio"
                        name="compType"
                        value="personal"
                        onClick={(e) => {
                          changeAccountType(e);
                        }}
                      />
                      <span className="checkmark" />
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <input
                    className="form-control p-3"
                    type="text"
                    placeholder={t("commonNav.loginModal.compCode")}
                    ref={$userSite}
                    onKeyPress={(e) => {
                      if (e.charCode === 13) {
                        actionLogin();
                      }
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="form-control p-3"
                    type="text"
                    placeholder={t("commonNav.loginModal.id")}
                    ref={$userID}
                    onKeyPress={(e) => {
                      if (e.charCode === 13) {
                        actionLogin();
                      }
                    }}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="form-control p-3"
                    type="password"
                    placeholder={t("commonNav.loginModal.password")}
                    ref={$userPW}
                    onKeyPress={(e) => {
                      if (e.charCode === 13) {
                        actionLogin();
                      }
                    }}
                  />
                </div>

                <div className="clearfix add_bottom_15">
                  <div className="checkboxes float-left">
                    <label className="container_check" htmlFor="saveID">
                      {t("commonNav.loginModal.autoLogin")}
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="saveID"
                        ref={$saveID}
                      />
                      <span className="checkmark" />
                    </label>
                  </div>
                </div>

                <div className="d-flex flex-row justify-content-center mb-3">
                  <a
                    className="text-secondary cursor_pointer_fw_bold"
                    data-toggle="modal"
                    data-target="#findIDModal"
                    href="#"
                    onClick={() => {
                      closeLoginModal();
                    }}
                  >
                    <p>{t("commonNav.loginModal.findID")}</p>
                  </a>
                  <p> | </p>
                  <a
                    className="text-secondary cursor_pointer_fw_bold"
                    data-toggle="modal"
                    data-target="#findPWModal"
                    href="#"
                    onClick={() => {
                      closeLoginModal();
                    }}
                  >
                    <p>{t("commonNav.loginModal.findPW")}</p>
                  </a>
                  <p> | </p>
                  <Link
                    className="text-secondary cursor_pointer_fw_bold"
                    to="/DeleteAccount"
                    onClick={() => {
                      $("#loginModalClose").click();
                    }}
                  >
                    <p>{t("commonNav.loginModal.requestDeleteAccount")}</p>
                  </Link>
                </div>

                <div className="text-center">
                  <button
                    value="Log In"
                    className="w-100 btn_1"
                    onClick={() => actionLogin()}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        Loading ...
                        <div
                          className="spinner-border spinner-border-sm text-light"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </>
                    ) : (
                      "Log in"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
